var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXenLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 56,
    viewBox: "60 180 360 120",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.028 196.89v101.637h-10.056V181.472h10.235l73.757 99.59v-99.59h10.056v117.055h-9.881zM211.1 298.527h58.689l5.1-9.173h-53.734v-99.341h48.634l5.1-8.54h-63.79z",
    fill: "#043754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.61 242.74v-8.498h35.22l-5.1 8.498z",
    fill: "#043754"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.395 181.473H68.612l44.576 57.034-47.208 60.02h11.783l47.206-60.02z",
    fill: "#12acde"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.002 298.527l-39.58-51.134-5.94 7.549 33.738 43.585zM169.195 181.473h-11.783l-30.99 40.417 5.947 7.61z",
    fill: "#043754"
  })));
}
export default SvgXenLogo;